export default __webpack_public_path__ + "static/media/relationshipFolder.8ff53146.svg";